import { socials } from "../config"

const Footer = () => {
    return(
        <footer className="px-5 md:px-32 py-3 bg-black text-white flex justify-between items-center">
            <span>© 2021 akbarputra.</span>
            <div className="flex gap-2">
                {socials.map(social => (
                    <a key={social.id} href={social.url} target="_blank" rel="noreferrer" className="w-8 h-8 bg-black hover:bg-primary transition ease-in-out rounded-full flex items-center justify-center">{social.icon}</a>
                ))}
            </div>
        </footer>
    )
}

export default Footer